import { HELP_LINKS, deepTransformKeys, toSnakeCase } from '~~core';

import { useRequirementStep } from '../use-requirement-step';

export function useRequirementHelpLink() {
  const { activeRequirement } = useRequirementStep();
  const { requirement: requirementLinks } = deepTransformKeys(HELP_LINKS, toSnakeCase);

  const currentHelpLink = computed(() => requirementLinks[activeRequirement.value] ?? HELP_LINKS.signingDocument);

  return {
    currentHelpLink,
  };
}
